import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { HotToastRef } from '@ngneat/hot-toast';
import { v4 as uuidv4 } from 'uuid';
export interface ToastData {
  message: string;
  type: 'info' | 'error' | 'success';
}

@Component({
  standalone: false,
  selector: 'm-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
  @Input() id = '';
  type: ToastData['type'];

  constructor(
    @Optional() @Inject(HotToastRef) public toastRef: HotToastRef<ToastData>
  ) {
    this.type = this.toastRef.data.type;
  }

  ngOnInit() {
    this.id = `toast-${uuidv4()}`;
    this.autoClose(3000);
  }

  autoClose(ms: number) {
    setTimeout(() => {
      this.toastRef.close();
    }, ms);
  }

  forceClose() {
    this.toastRef.close();
  }
}
